import {FINANCE_SERVER} from '@/constants/domains'
import VueCookie from 'vue-cookie'
import axios from 'axios'

export default {
  getTimer ({limit = 9999, page = 1, project = ''}) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    const fullRequest = [`page=${page}`, `limit=${limit}`]
    if (project) fullRequest.push(`project[]=${project}`)

    return instCred.get(`timer?${fullRequest.join('&')}`)
  },
  createTimer (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/start', body)
  },
  createSubTimer (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/subTimer', body)
  },
  pauseTimer (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/pause', body)
  },
  completeTimer (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/complete', body)
  },
  createManualTimer (body) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post('timer/createManual', body)
  },
  createCommentTimer (body, subTimerId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.post(`timer/createComment/${subTimerId}`, body)
  },
  deleteTimer (id) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.delete(`timer/deleteSubTimer/${id}`)
  },
  updateSubTimer (body, subTimerId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {'Authorization': 'Bearer ' + VueCookie.get('token')}
    })
    return instCred.put(`timer/subTimer/${subTimerId}`, body)
  },
  getActiveTimer (userId) {
    const instCred = axios.create({
      baseURL: FINANCE_SERVER,
      headers: {
        'Authorization': 'Bearer ' + VueCookie.get('token'),
        'company': VueCookie.get('company')
      }
    })
    return instCred.get(`timer/getActiveTimer/${userId}`)
  }
}



// WEBPACK FOOTER //
// ./src/api/Timer/api.js